// extracted by mini-css-extract-plugin
module.exports = {"profileRound":"ProfileBanner_profileRound__cu61l","profileInfoWrapper":"ProfileBanner_profileInfoWrapper__7yt16"};